import React, { Component } from 'react'
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, Grid, Checkbox, Popup, Message, FormField } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import "../Toolbar.css";

class Tag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setDisable: false,
            description: "",
            name: ""
        }
    }

    createTag = async (data) => {
        let tagObject = {
            accountId: this.props.selectedAccount._id,
            name: data.name,
            description: this.state.description
        };
        if (this.props.selectedTag && this.props.selectedTag._id) {
            tagObject.parent = this.props.selectedTag._id;
        }
        try {
            await dispatch.account.createTag(tagObject);
            if (!this.state.addAnotherTag) {

                this.handleClose();
            } else {
                document.getElementById("AddTagForm").reset();
                this.setState({ description: '' })
            }
        }
        catch (e) {
            this.setState({ addTagError: e })
        }
    }

    deleteTag = async (e) => {
        try {
            await dispatch.account.checkTagUsage(this.props.selectedTag._id);
            let message = <div className="confirmMessage">
                <h3>Delete Tag</h3>
                <label>{this.props.selectedTag.name}</label>
                <p>Are you sure that you wish to do this?</p>
                <span >This action is not reversible.{!this.props.selectedTag.subTag && <span>All its children will be removed with this</span>} </span>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    await dispatch.account.removeTag(this.props.selectedTag._id);
                }
            });

        } catch (error) {

            let message = <div className="confirmMessage">
                <h3>Delete Tag</h3>
                <label>{this.props.selectedTag.name}</label>
                {error.message}
            </div>
            toastr.confirm(message, {
                onOk: () => { },
                disableCancel: true
            });
            throw error;
        }
    }

    updateText = (data, name) => {

        // this.setState({ name: data })
        if (name === "name") {
            this.setState({ name: data, addTagError: null })
        }

        if (name === "Description") {
            this.setState({ description: data })
        }
    }
    setAddAnotherTag(event, data) {
        this.setState({ addAnotherTag: data.checked });
    }
    handleClose = () => {
        this.setState({
            addAnotherTag: false,
            addTagError: null,
            addTagModal: false,
            description: ''
        });
    }
    openAddTagModal = () => {
        this.setState({ addTagModal: true, name: '' });
    }
    render() {
        /**
         * User Access control 
         * Account user can not add or delete categories only owner can
         */
        let isDisabled = false;
        let userRoleInAccount = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0].role;
        if (userRoleInAccount === "user") {
            isDisabled = true;
        }
        let addTagHeader = this.props.selectedTag && this.props.selectedTag._id ? "Add Tag under " + this.props.selectedTag.name : "Add Tag"
        return (
            <div className="toolBar header_buttons">
                <Button.Group size='mini' >
                    {this.props.mainAreaContext === "tags" && ((this.props.selectedTag && !this.props.selectedTag.subTag) || this.props.selectedTag === {}) ?
                        <Popup className="popupStyled" inverted trigger={<span><Button
                            disabled={isDisabled}
                            icon='plus'
                            className="clr-green"
                            onClick={this.openAddTagModal} />
                        </span>}
                            content='Create Tag' />
                        : ''}
                    {this.props.mainAreaContext === "tags" && this.props.selectedTag && this.props.selectedTag._id ?
                        <Popup className="popupStyled" inverted trigger={<span><Button
                            icon='trash'
                            className="clr-orange"
                            onClick={this.deleteTag}
                            disabled={isDisabled} />
                        </span>}
                            content='Delete Tag'
                        /> : ''}
                    <Modal
                        open={this.state.addTagModal}
                        onClose={this.handleClose}
                        size='tiny'
                        className="basicModal"
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Header content={addTagHeader} />
                        <br /><br />
                        <Form noValidate
                            ref={ref => this.form = ref}
                            id="AddTagForm"
                            onValidSubmit={(event) => { this.createTag(event) }}
                        >
                            <Modal.Content>
                                <Grid>
                                    <Grid.Row className="">
                                        <Grid.Column width={16}>
                                            <TextEditor
                                                name="name"
                                                label="Name"
                                                text={this.state.name}
                                                type="text"
                                                onChangeText={this.updateText}
                                            />
                                            <FormField style={{ marginTop: '10px' }}>
                                                <TextEditor
                                                    name="Description"
                                                    text={this.state.description}
                                                    type="textarea"
                                                    onChangeText={this.updateText}
                                                />
                                            </FormField>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {this.state.addTagError && this.state.addTagError.code === 409 ?
                                        <span className="clr-red">Tag with same name already exists. Please enter another name.</span>
                                        : this.state.addTagError && this.state.addTagError.message ?
                                            <Message
                                                error
                                                content={this.state.addTagError.message}
                                            /> : ''}
                                </Grid>
                            </Modal.Content>
                            <Modal.Actions className="actionInFormcy">
                                <div style={{ textAlign: 'left' }}><br />
                                    <span>Add another tag</span>
                                    <Checkbox className='diamond-location' checked={this.state.addAnotherTag}
                                        onChange={(event, data) => this.setAddAnotherTag(event, data)} />
                                </div>

                                <Button
                                    className="button-submit float-right"
                                    disabled={this.state.name.length === 0}
                                    id='addbtn'
                                    type="submit"> Add </Button>
                                <Button
                                    id='cancelBtn'
                                    className="button-cancel"
                                    onClick={this.handleClose}> Cancel </Button>
                            </Modal.Actions>
                        </Form>
                    </Modal>
                </Button.Group>
            </div>
        )
    }
}
export default Tag